<template>
  <div class="trainers-list trainers-list-scrollable">
    <!--bookmarks list here-->
    <transition-group
      name="animated-list"
      tag="div"
      class="trainersCardsWrapper"
    >
      <TrainerCard
        v-for="[key, value] in bookmarksList"
        :key="key"
        :trainer="value"
      />
    </transition-group></div
></template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TrainerCard from '~/components/Search/TrainerCard'
export default {
  name: 'BookmarksList',
  components: { TrainerCard },
  props: {
    list: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bookmarksList: null
    }
  },
  computed: {
    ...mapGetters({
      bookmarksNumber: 'search/getBookmarksNumber'
    })
  },
  watch: {
    bookmarksNumber: {
      immediate: true,
      handler(val) {
        if (!val) this.showBookmarks(false)
        this.bookmarksList = Object.entries(this.list)
      }
    }
  },
  methods: {
    ...mapActions({
      showBookmarks: 'search/SHOW_BOOKMARKS'
    })
  }
}
</script>

<style scoped>
.animated-list-enter-active,
.animated-list-leave-active {
  transition: all 400ms;
}
.animated-list-enter, .animated-list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 60;
  transform: translateX(100vw);
}
</style>
